module.exports = __webpack_public_path__ + "img/head.7f2b23b1.png";